import { Container, List, Text, Title } from "@mantine/core";

export const View = () => {
  return (
    <Container mt={80}>
      <Title order={1}>
        Two Novel Performance Rating Instruments for Gynecological Procedures in
        Primary Care
      </Title>
      <Text color="dimmed" mb="xl">
        Funded by the Medical Council of Canada
      </Text>
      <Text mt="xl">
        Our team developed and provided validity evidence for performance rating
        instruments for four essential gynecological procedures in primary care.
        The global rating scale instrument is a instrument that allows for
        rating the overall technical skills performance of the trainees and the
        procedure-specific checklists uniquely designed for rating the
        performance of intrauterine device insertion, endometrial biopsy,
        routine pessary care and punch biopsy of vulva.
      </Text>
      <Text weight="bold" mt="xl">
        Research Team
      </Text>
      <List withPadding>
        <List.Item>
          <Text size="sm">
            Dr. Parisa Rezaiefar (Corresponding Author), MD, FCFPC, BSc.
            Department of Family Medicine at the University of Ottawa, and
            Bruyère Academic Family Health Team. PRezaiefar@bruyere.org, 75, rue
            Bruyère St., Ottawa, ON K1N 5C8, contact: 613-241-3344.
          </Text>
        </List.Item>
        <List.Item>
          <Text size="sm">
            Dr. Nisha Waqas MD Department of Family Medicine at the University
            of Ottawa.
          </Text>
        </List.Item>
        <List.Item>
          <Text size="sm">
            Dr. Douglas Archibald PhD Bruyère Research Institute, Department of
            Family Medicine, Department of Innovation in Medical Education, and
            the Faculty of Education at University of Ottawa.
          </Text>
        </List.Item>
        <List.Item>
          <Text size="sm">
            Dr. Susan Humphrey-Murto MD, MEd, FRCPC the Department of Medicine
            and the Department of Innovation in Medical Education at the
            University of Ottawa.
          </Text>
        </List.Item>
      </List>
    </Container>
  );
};
